// Availability.js
import axiosInstance from '@/lib/axios';



export async function participantsPOST(data) {

  const response = await axiosInstance.post('/users/event_participants', data);

  return response.data;

}

export async function participantsGET() {
  try {
    const response = await axiosInstance.get('/users/event_participants');
    return response.data;
  } catch (error) {
    if (error.response) throw new Error(error.response.data || 'Request failed');
    throw new Error(error.message);
  }
}

export async function participantsPATCH(user_id, data) {



  try {
    const response = await axiosInstance.patch(`/users/event_participants/events/${user_id}`, data);
    return response.status === 204 ? null : response.data;
  } catch (error) {

    alert(error.response.data.detail);

  }
}

export async function participantsDELETE(eventId) {
  try {
    const response = await axiosInstance.delete(`/users/event_participants/${eventId}`);
    return response.status === 204 ? null : response.data;
  } catch (error) {
    if (error.response) throw new Error(error.response.data || 'Request failed');
    throw new Error(error.message);
  }
}